export var FormFieldType;
(function (FormFieldType) {
    FormFieldType[FormFieldType["Integer"] = 1] = "Integer";
    FormFieldType[FormFieldType["Float"] = 2] = "Float";
    FormFieldType[FormFieldType["Text"] = 3] = "Text";
    FormFieldType[FormFieldType["Timestamp"] = 4] = "Timestamp";
    FormFieldType[FormFieldType["Textarea"] = 5] = "Textarea";
    FormFieldType[FormFieldType["Email"] = 6] = "Email";
    FormFieldType[FormFieldType["Select"] = 7] = "Select";
    FormFieldType[FormFieldType["Star"] = 8] = "Star";
    FormFieldType[FormFieldType["Radios"] = 9] = "Radios";
    FormFieldType[FormFieldType["NetPromoterScore"] = 10] = "NetPromoterScore";
    FormFieldType[FormFieldType["Buttons"] = 11] = "Buttons";
    FormFieldType[FormFieldType["Checkboxes"] = 12] = "Checkboxes";
    FormFieldType[FormFieldType["Boolean"] = 13] = "Boolean";
    FormFieldType[FormFieldType["SourcedSelect"] = 14] = "SourcedSelect";
    FormFieldType[FormFieldType["Date"] = 15] = "Date";
    FormFieldType[FormFieldType["Time"] = 16] = "Time";
    FormFieldType[FormFieldType["DateTime"] = 17] = "DateTime";
})(FormFieldType || (FormFieldType = {}));
export default FormFieldType;
//# sourceMappingURL=form-field-type.js.map